import AppSettings from '../../client-server-utils/AppSettings';

const appSettingsToUniqueString = (appSettings: AppSettings) => {
  const {
    contentful: { spaceId, environment, isPreview },
    language: { currentIso },
  } = appSettings;
  return `${spaceId}-${environment}-${isPreview ?? ''}-${currentIso}`;
};

export default appSettingsToUniqueString;
